import { IComponentProps } from '../../../model/studio';
import './index.scss';
import AuditHubIcon from '../../../assets/svg/text-chat-blue.svg';
import { useEffect, useState } from 'react';
import getFormatMessage from '../../../locales/get-format-message';
import classNames from 'classnames';
import { Select } from 'antd';
import {
  IAPIGameItem,
  IAPIUserInfo,
  IAuditItem,
} from '../../../model/api-modules';
import { IGameEnvModel } from '../../../model/api-modules/env';
import { fetchGameList } from '../../../api';
import { fetchEnvList } from '../../../api/game/env';
import { IframeComponent } from '../../game-content/game-console/iframe';
import { mergeURLParams, getGosHostname } from '../../game-content/lib';
import { parseVariablePath } from '../../../lib';
import { PermissionCheck } from '../../component/permission-check';
import { RbacRoleObjectKey } from '../../../model';
import Empty from '../../../assets/img/empty.png';
import { auditReadLog } from '../../lib/aduit-log';
import { queryAnyEnvWithOperationPerm } from './lib';
import { wrapTimeReport } from '../../lib/bk-report';
import { useSelector } from 'react-redux';
import { IRootState } from '../../../store/reducers';

const STUDIO_MANAGE_KEY = 'STUDIO_MANAGE_KEY';

export const AuditHubContentComponent = (props: IComponentProps) => {
  const [navPath, setNavPath] = useState<string>('Task');
  const [gameList, setGameList] = useState<IAPIGameItem[]>([]);
  const [envList, setEnvList] = useState<IGameEnvModel[]>([]);
  const [isSelectStudioManage, setIsSelectStudioManage] =
    useState<boolean>(false);
  const [selectGame, setSelectGame] = useState<string>('');
  const [selectEnv, setSelectEnv] = useState<number | null>(null);
  const [iframeSearch, setIframeSearch] = useState<Record<string, any> | null>(
    null
  );
  const [consoleSearch, setConsoleSearch] = useState<string>('');
  const studioID = props.studioInfo.studio.StudioID;
  const userInfo = useSelector((state: IRootState) => state.common.userInfo);

  window.addEventListener(
    'message',
    (event) => {
      if (event.data?.name === 'auditSearch') {
        if (event.data?.data) {
          setIframeSearch(event.data?.data);
        } else {
          setIframeSearch(null);
        }
      }
      console.log('Received from iframe:', event);
    },
    false
  );

  useEffect(() => {
    wrapTimeReport(queryGameList);
  }, []);

  useEffect(() => {
    if (iframeSearch) {
      let consoleIframeSearch = '';
      const searchKeys = Object.keys(iframeSearch);
      if (searchKeys && searchKeys.length !== 0) {
        searchKeys.forEach((item) => {
          consoleIframeSearch += `&${item}=${iframeSearch[item]}`;
        });
      }
      setConsoleSearch(consoleIframeSearch);
    }
  }, [selectEnv]);

  const getSearchValue = () => {
    const urlSearch = location.search.split('?');
    const searchValue: { [key: string]: string } = {};
    if (urlSearch.length > 1) {
      const searchArr = urlSearch[1].split('&');
      searchArr.forEach((item) => {
        const itemValue = item.split('=');
        searchValue[itemValue[0]] = itemValue[1];
      });
    }
    return searchValue;
  };

  const queryGameList = async () => {
    const res = await fetchGameList();
    setGameList(res || []);
    if (res) {
      const games = res.filter((v) => v.studioID === studioID && v.gameID);
      const searchValue = getSearchValue();
      let currentGame = games.length !== 0 ? games[0].gameID : '';

      if (
        searchValue.gameId &&
        games.find((item) => item.gameID === searchValue.gameId)
      ) {
        currentGame = searchValue.gameId;
      }
      setSelectGame(currentGame);
      queryEnvList(currentGame);
    }
  };

  const queryEnvList = async (gameID: string) => {
    if (gameID) {
      const res = await fetchEnvList(gameID);
      const searchValue = getSearchValue();
      setEnvList(res || []);
      if (res && res.length !== 0) {
        const env = res.find((item) => item.Guid === searchValue.envId);
        setSelectEnv(env ? env.id : res[0].id);
      }
    }
  };

  useEffect(() => {
    if (navPath === 'Task') {
      auditReadLog(IAuditItem.ViewAudithubTask);
    } else if (navPath === 'Operation') {
      auditReadLog(IAuditItem.ViewAudithubOperationreport);
    }
  }, [navPath]);

  const onClickNav = (path: string) => {
    setNavPath(path);
  };

  const changeGame = async (value: string) => {
    if (value === STUDIO_MANAGE_KEY) {
      setIsSelectStudioManage(true);
      setNavPath('Operation');
      const queryRes = await queryAnyEnvWithOperationPerm(studioID);
      if (!queryRes) {
        return;
      }
      setSelectGame(queryRes.game);
      await queryEnvList(queryRes.game);
      if (queryRes.env) {
        setSelectEnv(queryRes.env);
      }
      return;
    }
    queryEnvList(value);
    setSelectGame(value);
    setIsSelectStudioManage(false);
  };
  const changeEnv = (value: number) => {
    setSelectEnv(value);
  };

  const decodeEntities = (encodedString: string): string => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(encodedString, 'text/html');
    return doc.body.textContent || '';
  };

  const getGameEnvIframeURL = (
    env: IGameEnvModel,
    gameID: string,
    studioID: string,
    gameItem: IAPIGameItem | undefined,
    userInfo: IAPIUserInfo | null
  ) => {
    const params = mergeURLParams(
      studioID,
      gameID,
      env.Guid,
      gameItem,
      userInfo
    );
    let pathname = '';
    let hostname: string | undefined = undefined;

    // hostname = getGosHostname(gameID, env.GosParams);
    hostname = getGosHostname(env.GosParams);

    pathname = parseVariablePath('/g/{gameId}/1/gaas/audithub', {
      gameId: gameID,
    });
    if (navPath === 'Operation') {
      pathname = parseVariablePath('/g/{gameId}/1/gaas/operation', {
        gameId: gameID,
      });
    }

    if (hostname) {
      return decodeEntities(
        `${hostname}${pathname}${params}${consoleSearch || ''}`
      );
    }
    return null;
  };

  const renderIframeComponent = (url: string) => {
    return <IframeComponent name="AuditHub" url={url} />;
  };

  const renderEmptyComponent = () => {
    return (
      <div className="audit-empty">
        <img src={Empty} className="audit-empty-img" />
        <div className="audit-empty-tips">
          {getFormatMessage('per_audit_empty')}
        </div>
      </div>
    );
  };

  const renderIframe = () => {
    const env = envList.find((item) => item.id === selectEnv);
    const game = gameList.find((item) => item.gameID === selectGame);

    if (!env) {
      return null;
    }

    // open iframe
    const iframeURL = getGameEnvIframeURL(
      env,
      selectGame,
      studioID,
      game,
      userInfo
    );

    if (iframeURL && studioID) {
      const searchValue = getSearchValue();
      let currentIframeURL = iframeURL;
      if (searchValue.task) {
        currentIframeURL += `&task=${searchValue.task}`;
      }
      if (searchValue.subtask) {
        currentIframeURL += `&subtask=${searchValue.subtask}`;
      }
      if (isSelectStudioManage) {
        currentIframeURL += '&portal=1';
      }
      return renderIframeComponent(currentIframeURL);
    }
    return renderEmptyComponent();
  };

  const renderGame = () => {
    const games = gameList.filter((v) => v.studioID === studioID && v.gameID);
    return (
      <div className="audit-select">
        <Select
          style={{ width: 184, height: 32, marginTop: 16, marginLeft: 8 }}
          placeholder={getFormatMessage('please_select_game')}
          onChange={changeGame}
          dropdownMatchSelectWidth={false}
          value={isSelectStudioManage ? STUDIO_MANAGE_KEY : selectGame}
        >
          {[
            {
              gameID: STUDIO_MANAGE_KEY,
              gameName: getFormatMessage('studio_management'),
            },
            ...games,
          ].map((item) => {
            return (
              <Select.Option value={item.gameID}>{item.gameName}</Select.Option>
            );
          })}
        </Select>
        {!isSelectStudioManage && (
          <Select
            style={{ width: 184, height: 32, margin: '16px 0 0px 8px' }}
            placeholder={getFormatMessage('please_select_env')}
            notFoundContent={getFormatMessage('access_right_select_game_tips')}
            onChange={changeEnv}
            dropdownMatchSelectWidth={false}
            value={selectEnv}
          >
            {envList.map((item) => {
              return <Select.Option value={item.id}>{item.Name}</Select.Option>;
            })}
          </Select>
        )}
      </div>
    );
  };

  return (
    <div className="audit-hub-container">
      <div className="audit-hub-top">
        <div className="audit-line"></div>
        {/* <div className="current-nav-item">
          <span>{getFormatMessage('per_audit')}</span>
          <span className="current-nav-line">/</span>
          <span className="last-nav-name">{navPath}</span>
        </div> */}
      </div>
      <div className="audit-bottom">
        <div className="audit-nav-list">
          <div className="audit-nav-name">
            <img src={AuditHubIcon} className="audit-blue-icon" />
            {getFormatMessage('per_audit')}
          </div>
          {renderGame()}
          <div className="nav-list">
            {!isSelectStudioManage && (
              <div
                className={classNames('list-item', {
                  selected: navPath === 'Task',
                })}
                onClick={() => onClickNav('Task')}
              >
                {getFormatMessage('task_report')}
              </div>
            )}
            <div
              className={classNames('list-item', {
                selected: navPath === 'Operation',
              })}
              onClick={() => onClickNav('Operation')}
            >
              {getFormatMessage('operation_report')}
            </div>
          </div>
        </div>
        <PermissionCheck
          contentType="page"
          permissionKey={RbacRoleObjectKey.EnvView}
          gameID={selectGame}
          envID={selectEnv ? selectEnv.toString() : ''}
        >
          <div className="audit-content">{renderIframe()}</div>
        </PermissionCheck>
      </div>
    </div>
  );
};
